import { Form } from "antd";
import SelectCustom from "../../../Common/SelectCustom/SelectCustom";
import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import InputCustom from "../../../Common/InputCustom/InputCustom";
import { prefixSelector } from "../../../Util/Util";
import salamODB from "../../../../assets/salam-odb-logo.svg";
import dawiyatODB from "../../../../assets/dawiyat-odb-logo.svg";
import stcODB from "../../../../assets/stc-odb-logo.svg";
import mobilyODB from "../../../../assets/mobily-odb-logo.svg";
import salamODBSample from "../../../../assets/salam-sample.svg";
import dawiyatODBSample from "../../../../assets/dawiyat-sample.svg";
import stcODBSample from "../../../../assets/stc-sample.svg";
import mobilyODBSample from "../../../../assets/mobily-sample.svg";
import { getProductType } from "../../../../api/api";

const Fiber: React.FC<any> = () => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const { rtl, productType, userType, productFormData, cities,productBackListData } = state;
    const [selectedODB, setSelectedODB] = useState('')
    const [odbSample, setOdbSample] = useState('eg. RUH-UMHS-SULM-08-3891')
    const [packageNameOptions, setPackageNameOptions] = useState([]);
    const [productDataAll, setProductDataAll] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState<any>(productBackListData?.[0]?.productInformation?.packageName ? productBackListData[0].productInformation.packageName : {});
    const initialValues = {
      packageName: productFormData.packageName ? productFormData.packageName : '',
      ODBOperator: productFormData.ODBOperator ? productFormData.ODBOperator : '',
      ODBNumber: productFormData.ODBNumber ? productFormData.ODBNumber : '',
      city: productFormData.city ? productFormData.city : '',
      longitude: productFormData.longitude ? productFormData.longitude : '',
      latitude: productFormData.latitude ? productFormData.latitude : '',
      fullName: productFormData.fullName ? productFormData.fullName : '',
      mobileNumber: productFormData.mobileNumber ? productFormData.mobileNumber : '',
      prefix: productFormData.prefix ? productFormData.prefix : '966',
    };
    
    const ODBOperatorOptions = [
      {
        icon: <img src={mobilyODB} alt='mobily'/>,
        text: <span className="ms-1">{t("MobilyODB")}</span>,
        value: 'mobily'
      },
      {
        icon: <img src={stcODB} alt='STC'/>,
        text: <span className="ms-1">{t("STC")}</span>,
        value: 'stc'
      },
      {
        icon: <img src={dawiyatODB} alt='Dawiyat'/>,
        text: <span className="ms-1">{t("Dawiyat")}</span>,
        value: 'dawiyat'
      },
      {
        icon: <img src={salamODB} alt='Salam'/>,
        text: <span className="ms-1">{t("Salam")}</span>,
        value: 'salam'
      }
    ]
    useEffect(() => {
      dispatch({ type: "LOADER", payload: { loading: true } });

      getProductType('DIG_FIBER_SIP_PKG').then((res) => {
        const productOpt: any = res.data;
        setProductDataAll(productOpt.data);
        const packageOption = [];
        productOpt.data.products_list.sort((a: any, b: any) => parseInt(a.order_priority) - parseInt(b.order_priority))
        console.log(productOpt.data.products_list, 'productOpt.data.products_list')
        for (let i = 0; i < productOpt.data.products_list.length; i++) {
          if (productOpt.data.products_list[i].product_type === "Fiber") {
            const opt = {
                value: "",
                name: "",
                productName: "",
                price: '',
                text: ''
            };
            opt.name = opt.value = opt.text = rtl
              ? (productOpt.data.products_list[i].product_name_ar)
              : (productOpt.data.products_list[i].product_name_en);
            opt.price = productOpt.data.products_list[i].mrc;
            packageOption.push(opt);
          }
        }
        setPackageNameOptions(packageOption);
      })
      dispatch({ type: "LOADER", payload: { loading: false } });
    }, [dispatch, rtl, t]);
    const handleNext = async (values: any) => {
      try {
        const res = await form.validateFields();
        const newList = [{
          productInformation: {
            productType: { value: productType },
            ODBOperator: { value: res.ODBOperator},
            ODBNumber: { value: res.ODBNumber},
            city: { value: res.city},
            longitude: { value: res.longitude},
            latitude: { value: res.latitude},
            fullName: { value: res.fullName},
            mobileNumber: { value: res.mobileNumber },
            quantity: { value: 1 },
            packageName: { ...selectedPackage, value: res.packageName }
          }
        }];
        dispatch({
          type: "PRODUCT_INFORMATION",
          payload: { 
            values: newList,
            productList: newList,
            page: t("Download_Attach"),
            modalOpen: userType === 'newcustomer' ? false : true,
            productFormData: res
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
    const handleChange = (e: any) => {
      switch (e) {
        case 'mobily':
          setOdbSample('eg. RUH-UMHS-SULM-08-3891');
          setSelectedODB(mobilyODBSample);
          break;
        case 'stc':
          setOdbSample('eg. RBUARDU6701');
          setSelectedODB(stcODBSample);
          break;
        case 'dawiyat':
          setOdbSample('eg. D0543931001');
          setSelectedODB(dawiyatODBSample);
          break;
        case 'salam':
          setOdbSample('eg. RDJRIR05137');
          setSelectedODB(salamODBSample);
          break;
      }
    }
    const handlePackageChange = (value: any, formName: string, fieldName: string) => {
      form.setFieldValue(fieldName, value);
      if (fieldName === 'packageName') {
        const jsonResData: any = productDataAll;
        const packageResponse = jsonResData.products_list.filter((res: any) => rtl ? res.product_name_ar === value : res.product_name_en === value)[0];
        if (packageResponse) {
          const packageData: any = {};
          packageData.price = packageResponse.mrc;
          packageData.mrc = packageResponse.mrc;
          packageData.nrc = packageResponse.nrc;
          packageData.mode_sfaId = packageResponse.mode_sfa_id;
          packageData.product_Id = packageResponse.product_id;
          packageData.packageType_sfaId = packageResponse.package_type_sfa_id;
          packageData.name = value;
          setSelectedPackage(packageData);
        } else {
          form.setFields([
            {
              name: 'quantity',
              value: '',
              errors: [t('Package_Not_Available')],
            }
          ])
        }
      }
    };
    return (
        <div className="row">
            <div className="col-md-8">
                <Form form={form} name="accordionForm" initialValues={initialValues} onFinish={handleNext}>
                    <SelectCustom
                        headingLeft={t('FiberNet_Package')}
                        name="packageName"
                        options={packageNameOptions}
                        placeholder={t(`Choose_Speed`)}
                        handleChange={(value: any) => {
                          handlePackageChange(value, "productInformation", "packageName");
                        }}
                        rules={[
                            { required: true, message: `${t("Please_Enter")} ${t("FiberNet_Package")}` },
                        ]}
                    />
                    <Typography rtl={rtl} fontSize="32px" fontWeight="700" fontFamily="ScandiaWeb-Bold">{t('Fiber_Optic_Distribution')}</Typography>
                    <Typography rtl={rtl} fontSize="16px" fontWeight="400" className="mb-3">{t('Fiber_Optic_Distribution_Description')}</Typography>
                    <SelectCustom
                      headingLeft={t("ODB_Operator")}
                      name="ODBOperator"
                      options={ODBOperatorOptions}
                      placeholder={t(`Select_ODB_Operator`)}
                      onChange={handleChange}
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("ODB_Operator")}` },
                      ]}
                    />
                    <InputCustom
                      rtl={rtl}
                      maxLength={25}
                      headingleft={t("ODB_Number")}
                      name="ODBNumber"
                      rules={[{ required: true, message: `${t("Please_Enter")} ${t("ODB_Number")}` }]}
                      placeholder={odbSample}
                    />
                    <SelectCustom
                      headingLeft={t("City")}
                      name="city"
                      options={cities}
                      placeholder={t(`Choose_City`)}
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("City")}` },
                      ]}
                    />
                    <InputCustom
                      rtl={rtl}
                      maxLength={13}
                      headingleft={t("Longitude")}
                      name="longitude"
                      rules={[{ required: true, message: `${t("Please_Enter")} ${t("Longitude")}` }]}
                      placeholder={`eg. 24°42'29"N or 24.70828964645712`}
                    />
                    <InputCustom
                      rtl={rtl}
                      maxLength={13}
                      headingleft={t("Latitude")}
                      name="latitude"
                      rules={[{ required: true, message: `${t("Please_Enter")} ${t("Latitude")}` }]}
                      placeholder={`eg. 46°40'31"E  or  46.67543543191265`}
                    />
                    <Typography rtl={rtl} fontSize="32px" fontWeight="700" fontFamily="ScandiaWeb-Bold">{t('Technical_Contact')}</Typography>
                    <Typography rtl={rtl} fontSize="16px" fontWeight="400" className="mb-3">{t('Technical_Contact_Description')}</Typography>
                    <InputCustom
                      rtl={rtl}
                      headingleft={t("Full_Name")}
                      placeholder={t("Enter_full_name")}
                      name="fullName"
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("Full_Name")}` },
                          { pattern: /^[\u0621-\u064A0-9a-zA-Z\s]{2,50}$/, message: t("Verify_entered_data") }
                      ]}
                    />
                    <InputCustom
                      rtl={rtl}
                      headingleft={t("Mobile_Number")}
                      placeholder={t("Enter_phone_number")}
                      name="mobileNumber"
                      prefixSelector={prefixSelector()}
                      maxLength={9}
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("Mobile_Number")}` },
                          { pattern: /^((5)([0-9]{8})){0,9}$/, message: t("Verify_entered_info") }
                      ]}
                    />
                    <IconButton width={"130px"} htmlType='submit' rtl={rtl} className="next-button mt-2">
                        {t("Next")}
                    </IconButton>
                </Form>
            </div>
            {selectedODB && <div className="col-sm-4 text-center">
              <img src={selectedODB} alt='sample' height={243} width={176}/>
            </div>}
        </div>
    )
}

export default Fiber;
